<template>  
  <format
    :msg="$t('online-slot')"
    :type-game="4"
    :src="require('@/assets/nav/submenu/icon_submenu15.svg')"
  />
</template>
<script>  
import format from './childs/format'

export default {

  components : {
    format
  }  
} 
</script> 